module.exports = __webpack_public_path__ + "static/media/tumb5.8ff15760.png";